import { z } from 'zod'

const jsonResponseSchema = z.object({}).passthrough()

export const billingAutoTopupWriteConfigResponseSchema = jsonResponseSchema
export const billingAutoTopupWriteTestResponseSchema = jsonResponseSchema
export const billingAutoTopupWriteReenableResponseSchema = jsonResponseSchema

export type BillingAutoTopupWriteConfigResponse = z.infer<typeof billingAutoTopupWriteConfigResponseSchema>
export type BillingAutoTopupWriteTestResponse = z.infer<typeof billingAutoTopupWriteTestResponseSchema>
export type BillingAutoTopupWriteReenableResponse = z.infer<typeof billingAutoTopupWriteReenableResponseSchema>
